module.exports = __webpack_public_path__ + "static/media/2020-10-24 recommendation-systems.13624a1d.md";